import {createAction} from "@reduxjs/toolkit";
import {IFavoriteDeleteItem, ISelectedPrecisions, ITOHistory} from "../types";

export const setIsStoppedByToDetails = createAction<boolean>('setIsStoppedByToDetails')
export const setFeeFilter = createAction<number | undefined>('setFeeFilter')
export const setHideNumFilter = createAction<number | undefined>('setHideNumFilter')
export const setHighlightFrom = createAction<number | undefined>('setHighlightFrom')
export const setHiddenExchanges = createAction<string[]>('setHiddenExchanges')
export const setFilterPercent = createAction<number | undefined>('setFilterPercent')
export const setIsToDetailsOpen = createAction<boolean>('setIsToDetailsOpen')
export const setIsSettingsOpen = createAction<boolean>('setIsSettingsOpen')
export const setIsFavoriteOpen = createAction<boolean>('setIsFavoriteOpen')
export const setIsMenuOpen = createAction<boolean>('setIsMenuOpen')
export const setIsPlay = createAction<boolean>('setIsPlay')
export const setIsInfoOpen = createAction<boolean>('setIsInfoOpen')
export const setSelectedItem = createAction<ITOHistory | undefined>('setSelectedItem')
export const setSelectedItemIndex = createAction<number | undefined>('setSelectedItemIndex')
export const setCurrentHistoryState = createAction<ITOHistory[]>('setCurrentHistoryState')
export const setFavorites = createAction<IFavoriteDeleteItem[]>('setFavorites')
export const setDeleted = createAction<IFavoriteDeleteItem[]>('setDeleted')
export const setSelectedPrecisions = createAction<ISelectedPrecisions | undefined>('setSelectedPrecisions')
export const setLang = createAction<'en' | 'ua'>('setLang')
export const setIsLangOpen = createAction<boolean>('setIsLangOpen')